/** Uygulama arka plan müziğini durdur (intro videosu vb.). */
export function pauseAppBackgroundMusic() {
  document.querySelectorAll('audio').forEach((audio) => {
    if (audio.dataset?.introVideo === 'true') return;
    audio.pause();
    audio.currentTime = 0;
  });
  window.dispatchEvent(new CustomEvent('text2:pause-background-music'));
}
